// Therapist registration

import { createApp } from 'vue/dist/vue.esm-bundler';
import InternshipList from './InternshipList.vue';

const LpCareerInternshipList = document.querySelector('#LpCareerInternshipList');

if ( LpCareerInternshipList )
{
  createApp({
    components: {
      InternshipList
    }
  }).mount('#LpCareerInternshipList');
}